export enum SimpleTestingType {
    DesignImplementation = 10,
    Effectiveness = 20,
}
